import React, {Fragment, useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {
    Button,
} from "@material-ui/core";
import ProgressBar from "../../../../customer/ProductsCustomer/ProgressBar";
import {Formik, Form} from "formik";
import Loading from "../../../../Loading";

import ValidationSchema from "./FormModel/validationSchema";
import FormModel from "./FormModel/formModel";
import FormInitialValues from "./FormModel/formInitialValues";

import useStyles from "./styles";

import TitularForm from "./Forms/TitularForm";
import EmpleoForm from "./Forms/EmpleoForm";
import prevencion_white_icon from "../../../../../assets/images/prevencion_white_icon.png";
import Axios from "axios";

import AffinityContext from "../../../../../context/AffinityContext";
import close_x from "../../../../../assets/images/close_x.png";
import {formatPhoneNumberIntl} from "react-phone-number-input";
import moment from "moment";

const steps = ["Cliente", "Empleo"];
const {formId, formField} = FormModel;


function _renderStepContent(step, localidades) {
    switch (step) {
        case 0:
            return <TitularForm
                formField={formField}
                localidadesData={localidades}/>;
        case 1:
            return <EmpleoForm formField={formField}/>;
        default:
            return <div>Not Found</div>;
    }
}

export default function CheckoutCustomerCotizar(props) {

    const {
        localidades,
        affinityId,
        affinityInterCode,
    } = useContext(AffinityContext);

    let modifiedFormInitialValues = {
        ...FormInitialValues
    }
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const history = useHistory();
    const currentValidationSchema = ValidationSchema[activeStep];
    const isLastStep = activeStep === steps.length - 1;

    const [valuesModal, setValuesModal] = useState([]);
    const [actionsModal, setActionsModal] = useState(null);
    const [localidadesMap, setLocalidadesMap] = useState(null)
    const {confirmationModalOpen, setConfirmationModalOpen, isMobile, scrollIntoView} = props;

    async function _submitForm(values, actions) {
        let url = process.env.REACT_APP_BACK_SERVER + '/precotizar/prevencion'

        values.idAfinidad = affinityId
        values.Tipo = "PREVENCION SALUD"

        values.codArea = formatPhoneNumberIntl(values.telefono).split(' ')[1]
        values.telefono = `${formatPhoneNumberIntl(values.telefono).split(' ')[2]}${formatPhoneNumberIntl(values.telefono).split(' ')[3]}`
        values.fechaNacimiento = moment(values.fechaNacimiento, 'YYYY-MM-DD').format('YYYY-MM-DD')

        Axios.post(url, values).then((result) => {
            console.log(result.status)
            actions.setSubmitting(false);
        }).catch((error) =>
            console.log(error));

        setActiveStep(activeStep + 1);
    }

    function _handleSubmit(values, actions) {
        scrollIntoView()
        if (isLastStep) {
            actions.setTouched({});
            actions.setSubmitting(false);
            setValuesModal(values);
            setActionsModal(actions)
            setConfirmationModalOpen(true);
        } else {
            setActiveStep(activeStep + 1);
            actions.setTouched({});
            actions.setSubmitting(false);
        }
    }

    function _handleBack() {
        setActiveStep(activeStep - 1);
    }

    const handleClose = () => {
        setConfirmationModalOpen(false);
    }

    useEffect(() => {
        let options = localidades.map(d => ({
            "value": d.CodPostal.toString() + ',' + d.CodSancorLocalidad.toString(),
            "label": '(' + d.CodPostal.toString() + ') ' + d.Localidad
        }));
        setLocalidadesMap(options);

    }, [localidades])

    return (
        <React.Fragment>
            {localidadesMap ?
                <>
                    <div
                        className={classes.iconCircle}
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "-50px",
                            height: "50px"
                        }}
                    >
                        <img src={prevencion_white_icon} alt="prevencion_icon" style={{width: "24px", height: "auto"}}/>
                    </div>

                    <div style={{margin: "16px 0"}}>
                        <ProgressBar activeStep={activeStep} stepTitles={steps}/>
                    </div>

                    <Fragment>
                        <Formik
                            initialValues={modifiedFormInitialValues}
                            validationSchema={currentValidationSchema}
                            validateOnBlur={false}
                            onSubmit={_handleSubmit}
                        >
                            {({isSubmitting}) => (
                                <Form id={formId}>
                                    {_renderStepContent(activeStep, localidadesMap)}
                                    <div className={classes.buttons}>
                                        {activeStep !== 0 && (
                                            <div className={classes.buttons}>
                                                <Button
                                                    onClick={_handleBack}
                                                    className={classes.backButton}
                                                    variant="contained"
                                                    style={ isMobile ? {fontSize: "14px"} : {fontSize: "16px"}}
                                                >
                                                    Atras
                                                </Button>
                                            </div>
                                        )}
                                        <div className={classes.buttons}>
                                            <Button
                                                className={classes.buttonContained}
                                                disabled={isSubmitting}
                                                type="submit"
                                                variant="contained"
                                                style={ isMobile ? {fontSize: "14px"} : {fontSize: "16px"}}
                                            >
                                                {isLastStep ? "Solicitar cotización" : "Siguiente"}
                                            </Button>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Fragment>
                </>
                :
                <Loading/>}

            {confirmationModalOpen &&
            <div className={isMobile ? classes.modalMainMobile : classes.modalMainDesktop}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                    <img
                        style={{
                            marginTop: "5px",
                            marginRight: "10px",
                        }}
                        onClick={handleClose}
                        src={close_x}
                        width={"12px"}
                        height={"12px"}
                    />
                </div>
                <div className={classes.modalColumn}>
                    <p className={classes.modalTitle} style={{marginBottom: "16px", marginTop: "16px"}}> ¿Confirma su
                        información de contacto? </p>
                    <div>
                        <p className={classes.modalSubtitle}> Email </p>
                        <p className={classes.modalText2}> {valuesModal.email} </p>
                        <p className={classes.modalSubtitle}> Celular </p>
                        <p className={classes.modalText2}
                           style={{marginBottom: "24px"}}> {(valuesModal.telefono).toString()} </p>
                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "16px"
                    }}>
                        <button className={classes.modalButtonModify} onClick={() => {
                            setActiveStep(0);
                            setConfirmationModalOpen(!confirmationModalOpen)
                        }}>
                            Modificar
                        </button>
                        <button className={classes.modalButtonConfirm} onClick={() => {
                            setConfirmationModalOpen(!confirmationModalOpen)
                            _submitForm(valuesModal, actionsModal).then(() => history.push(`/a/${affinityInterCode}/${affinityId}/end`));
                        }}>
                            Confirmar
                        </button>
                    </div>
                </div>

            </div>}
        </React.Fragment>
    );
}
